module.exports = __webpack_public_path__ + "img/casesnopposmall.a2f7d16c.png";